import styled from 'styled-components';
import media from '../../styled/media';

export const Heading = styled.h1`
  color: #4a4a4a;
  text-align: center;
  font-size: 30px;
  line-height: 32px;
  font-weight: 400;
  margin: 24px 0;
  ${media.tablet`
    font-size: 48px;
    line-height: 70px;
  `}
`;

export const Subheading = styled.p`
  color: #4a4a4a;
  text-align: center;
  font-size: 18px;
  line-height: 26px;
  margin: 24px 0;
  ${media.tablet`
    font-size: 22px;
    line-height: 40px;
  `}
`;

export const Text = styled.p`
  color: #4a4a4a;
  font-size: 18px;
  line-height: 32px;
  margin: 24px 0;
  a {
    text-decoration: none;
    &:after {
      content: '';
      display: inline-block;
      width: 19px;
      height: 13px;
      background: url('/images/company/icon-right-arrow.svg') no-repeat center;
      margin-left: 8px;
    }
  }
  ${media.tablet`
    font-size: 22px;
    line-height: 38px;
    a {
      text-decoration: underline;
    }
  `}
`;

export const Awards = styled.div`
  display: flex;
  overflow: scroll;
  margin: 40px -20px;
`;

export const AwardsItem = styled.div`
  width: 200px;
  min-width: 200px;
  text-align: center;
  padding: 0 10px;
`;

export const AwardsItemTitle = styled.p`
  font-size: 14px;
  line-height: 21px;
`;

export const Features = styled.div`
  display: flex;
  flex-wrap: wrap;
`;

export const FeaturesItem = styled.div`
  text-align: center;
  width: 100%;
  ${media.tablet`
    width: 50%;
  `}
`;

export const FeaturesItemTitle = styled.p`
  color: #4a4a4a;
  font-size: 18px;
  line-height: 32px;
`;

export const Row = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  margin: 40px 0;
  ${media.tablet`
    margin: 80px 0;
  `}
`;

export const Column = styled.div`
  width: 100%;
  ${media.tablet`
    width: 50%;
    padding-right: 20px;
  `}
`;

export const ColumnInverted = styled(Column)`
  ${media.tablet`
    order: 1;
    padding-left: 20px;
  `}
`;

export const Flags = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  ${media.tablet`
    flex-direction: row;
    justify-content: space-between;
  `}
`;

export const FlagsItem = styled.div`
  margin: 24px auto;
`;
